<template>
  <div class="slider-row">
    <zoom-in-icon class="marginIcon" @click="decreaseZoom" />
    <vue-slider
      v-model="zoom"
      :min="min"
      :max="max"
      :interval="0.01"
      tooltip="none"
      class="slider-row__slider"
    />
    <zoom-out-icon class="marginIcon" @click="increaseZoom" />
  </div>
</template>

<script>
import VueSlider from "vue-slider-component";

/** icons */
import ZoomInIcon from "vue-material-design-icons/MagnifyPlusOutline.vue";
import ZoomOutIcon from "vue-material-design-icons/MagnifyMinusOutline.vue";

export default {
  name: "CutZoomSlider",
  components: {
    VueSlider,
    ZoomInIcon,
    ZoomOutIcon
  },
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    /** zoom value in range 0-1 (the bigger - the farer) */
    value: {
      type: Number,
      default: 1
    },
    /** minimum zoom value (nearest position) */
    min: {
      type: Number,
      default: 0.05
    },
    /** maximum zoom value (farest position) */
    max: {
      type: Number,
      default: 1
    },
    /** zoom change step by buttons */
    zoomStep: {
      type: Number,
      default: 0.05
    }
  },
  data() {
    return {
      /** local zoom value */
      zoom: this.value
    };
  },
  watch: {
    // @vuese
    // Update zoom-prop when local value has changed
    zoom() {
      this.$emit("change", this.zoom);
    },
    // @vuese
    // Change local zoom when prop has changed
    value() {
      this.zoom = this.value;
    }
  },
  methods: {
    // @vuese
    // Increase zoom by one step
    increaseZoom() {
      this.zoom = Math.min(this.max, this.zoom + this.zoomStep);
    },
    // @vuese
    // Decrease zoom by one step
    decreaseZoom() {
      this.zoom = Math.max(this.min, this.zoom - this.zoomStep);
    }
  }
};
</script>

<style scoped lang="scss">
.marginIcon {
  margin-top: -7px;
  margin-right: -10px;
}

.slider-row {
  display: flex;

  &__slider {
    width: 100% !important;
    margin: 0 12px;
  }
}
</style>
